export { default as FaIcon } from './FaIcon/FaIcon';
export {
  faChevronRight,
  faClock,
  faSearch,
  faChevronUp,
  faChevronLeft,
  faChevronDown,
  faExclamationCircle,
  faTruck,
  faSync,
  faXTwitter,
  faInstagram,
  faYoutube,
  faTiktok,
} from './FaIcon/FaIcon';
